import { Box, HStack, Heading, Progress, Spacer, Stack, Text, useColorMode } from '@chakra-ui/react'

export const Stat = (props) => {
    const { colorMode } = useColorMode();
    const { label, value, limit, color, since, ...boxProps } = props

    const backgroundColor = colorMode === 'light' ? 'gray.30' : 'gray.700';

    function formatToLocalDate(dateStr) {
        const date = new Date(dateStr);

        const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        };

        return new Intl.DateTimeFormat('es-ES', options).format(date);
    }

    return (
        <Box bg={backgroundColor} rounded='10px' boxShadow="md" {...boxProps}>
            <Box
                px={{
                    base: '4',
                    md: '6',
                }}
                py={{
                    base: '5',
                    md: '6',
                }}
            >
                <Stack >
                    <HStack>
                        <Text fontSize={{
                            base: 'lg',
                            md: 'lg',
                        }} color="fg.muted">
                            {label}
                        </Text>
                        <Spacer />
                        {since && <Text >{`Desde el ${formatToLocalDate(since)}`}</Text>}</HStack>
                    <Stack direction="row" align="baseline">
                        <Heading
                            size={{
                                base: 'lg',
                                md: 'lg',
                            }}
                        >
                            {value}
                        </Heading>

                        <Text aria-hidden fontWeight="semibold" color="fg.muted">
                            {limit && "/"} {limit}
                        </Text>
                        <Box srOnly>out of {limit}</Box>

                    </Stack>

                </Stack>{limit && <Progress value={(value / limit) * 100} size="xs" borderRadius="none" bg={color} />}
            </Box>

        </Box>
    )
}